import useTranslation from 'next-translate/useTranslation'

import BodyText from '../../../../app/components/BodyText'

function CopyrightNotice() {
  const { t } = useTranslation('generated')

  return (
    <BodyText color="body-1">
      © {new Date().getFullYear()} {t('copyrightBrandName')}
    </BodyText>
  )
}

export default CopyrightNotice
